import { render, staticRenderFns } from "./DeletedEntriesList.vue?vue&type=template&id=15e46e87&scoped=true"
import script from "./DeletedEntriesList.vue?vue&type=script&lang=js"
export * from "./DeletedEntriesList.vue?vue&type=script&lang=js"
import style0 from "./DeletedEntriesList.vue?vue&type=style&index=0&id=15e46e87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e46e87",
  null
  
)

export default component.exports